import type { SxProps, Theme } from '@mui/material/styles';
import { STATUS_COLORS, type StatusTone } from '../utils/statusTonePalette';

export const groupLabelSx: SxProps<Theme> = {
  m: 0,
  fontSize: 12,
  lineHeight: '18px',
  // Figma's weight; the theme only defines 600 and 800
  fontWeight: 700,
  textTransform: 'uppercase',
  color: 'text.secondary',
};

export const chipSx = (tone: StatusTone): SxProps<Theme> => ({
  gap: 0.5,
  pl: 0.75,
  pr: 1.25,
  '& .MuiSvgIcon-root': { color: STATUS_COLORS[tone].strong },
});

export const emphasisSx: SxProps<Theme> = { fontWeight: 'fontWeightBold' };

// keeps the included/excluded status readable for screen readers, which skip the icon
export const srOnlySx: SxProps<Theme> = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  p: 0,
  m: '-1px',
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  whiteSpace: 'nowrap',
  border: 0,
};
